import { createRouter, createWebHistory } from "vue-router";
import HomeView from "@/views/HomeView.vue";
import AboutView from "../views/AboutView.vue";
import ContactView from "../views/ContactView.vue";
import PrivacyPolicyView from "../views/PrivacyPolicyView.vue";
import TermsAndConditionsView from "../views/TermsAndConditionsView.vue";
import ScholarshipView from "../views/ScholarshipView.vue";
import AdminLoginView from "../views/AdminLoginView.vue";
import AdminDashboard from "../views/AdminView.vue";
import AppView from "../views/AppView.vue";
import AppLoginView from "../views/AppLoginView.vue";
import AppRegisterView from "../views/AppRegisterView.vue";
import ApplicationFormView from "@/views/ApplicationFormView.vue";
import DepartmentDetails from "@/components/DepartmentDetails.vue";
import MatricFrame from "../views/MatricFrame.vue";
// Layouts
import AppLayout from "../layouts/AppLayout.vue";

const routes = [
  {
    path: "/",
    name: "home",
    component: HomeView,
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: AboutView,
    // () =>
    //   import(/* webpackChunkName: "about" */ "../views/AboutView.vue"),
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactView,
  },
  {
    path: "/privacy",
    name: "privacy",
    component: PrivacyPolicyView,
  },
  {
    path: "/terms",
    name: "terms",
    component: TermsAndConditionsView,
  },
  {
    path: "/department/:slug",
    name: "department",
    component: DepartmentDetails,
    props: true,
  },
  {
    path: "/funding",
    name: "funding",
    component: ScholarshipView,
  },
  {
    path: "/matric-frame",
    name: "matricFrame",
    component: MatricFrame,
    meta: { title: "Matric Frame - First City Polytechnic" },
  },
  {
    path: "/admin",
    name: "adminLogin",
    component: AdminLoginView,
    meta: { hideHeader: true, hideFooter: true },
  },
  {
    path: "/admin-dashboard",
    name: "adminDashboard",
    component: AdminDashboard,
    meta: { hideHeader: true, hideFooter: true, requiresAdminAuth: true },
  },
  {
    path: "/app",
    component: AppLayout,
    meta: { hideHeader: true, hideFooter: true, requiresAuth: true },
    children: [
      {
        path: "",
        name: "app",
        component: AppView,
        meta: { title: "Dashboard" },
      },
      {
        path: "auth",
        name: "login",
        component: AppLoginView,
        meta: { title: "Login", guest: true },
      },
      {
        path: "apply",
        name: "register",
        component: AppRegisterView,
        meta: { title: "Register", guest: true },
      },

      {
        path: "appForm",
        name: "application",
        component: ApplicationFormView,
        meta: { title: "Application" },
      },
    ],
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

// Navigation Guard for Authentication Handling
router.beforeEach((to, from, next) => {
  const isAdminLoggedIn = !!localStorage.getItem("admin"); // Admin authentication
  const isUserLoggedIn = !!localStorage.getItem("user"); // App user authentication

  if (to.matched.some((record) => record.meta.requiresAdminAuth)) {
    if (!isAdminLoggedIn) {
      if (to.name !== "adminLogin") {
        return next({ name: "adminLogin" });
      }
    }
  } else if (to.name === "adminLogin" && isAdminLoggedIn) {
    return next({ name: "adminDashboard" });
  }

  // Prevent logged-in users from accessing guest pages like /app/auth
  if (to.matched.some((record) => record.meta.guest) && isUserLoggedIn) {
    if (to.name !== "app") {
      return next({ name: "app" }); // Redirect to dashboard if not already there
    }
  }

  // Prevent non-logged-in users from accessing protected pages
  if (
    to.matched.some((record) => record.meta.requiresAuth) &&
    !isUserLoggedIn
  ) {
    if (to.name !== "login") {
      return next({ name: "login" }); // Redirect to login if not already there
    }
  }

  next(); // Proceed normally if no redirects are needed
});

export default router;
